import {
  listFeedbacks,
  createFeedback,
  updateFeedback,
  deleteFeedback,
  getFeedback as getFeedbackService,
  listEscalations,
  reassignFeedback as reassignFeedbackService,
  acceptFeedback as acceptFeedbackService,
  startProcessingFeedback as startProcessingFeedbackService,
  updateProgressFeedback as updateProgressFeedbackService,
  respondFeedback as respondFeedbackService,
  resultUpdateFeedback as resultUpdateFeedbackService,
  proposeChiefFeedback as proposeChiefFeedbackService,
  collaborateFeedback as collaborateFeedbackService,
  reinforceFeedback as reinforceFeedbackService,
  acceptProposeFeedback as acceptProposeFeedbackService,
  resolveWorkflowFeedback as resolveWorkflowFeedbackService,
  changePriorityFeedback as changePriorityFeedbackService,
  acceptCollaborationFeedback as acceptCollaborationFeedbackService,
  forwardCollaborationFeedback as forwardCollaborationFeedbackService,
  directiveFeedback as directiveFeedbackService,
} from "app/services/feedback.service.js";
import {
  FEEDBACKS_REQUEST,
  FEEDBACKS_FAILURE,
  FETCH_FEEDBACKS_SUCCESS,
  CREATE_FEEDBACKS_SUCCESS,
  DELETE_FEEDBACKS_SUCCESS,
  UPDATE_FEEDBACKS_SUCCESS,
  GET_FEEDBACKS_SUCCESS,
  FETCH_ESCALATIONS_SUCCESS,
  REALTIME_FEEDBACK_RECEIVED,
} from "./types";

export const feedbackRequest = () => ({
  type: FEEDBACKS_REQUEST,
});

export const feedbackFailure = (error) => ({
  type: FEEDBACKS_FAILURE,
  payload: error,
});

export const fetchFeedbacksSuccess = (feedbacks) => ({
  type: FETCH_FEEDBACKS_SUCCESS,
  payload: feedbacks,
});

export const createFeedbackSuccess = (feedback) => ({
  type: CREATE_FEEDBACKS_SUCCESS,
  payload: feedback,
});

export const updateFeedbackSuccess = (feedback) => ({
  type: UPDATE_FEEDBACKS_SUCCESS,
  payload: feedback,
});

export const deleteFeedbackSuccess = (id) => ({
  type: DELETE_FEEDBACKS_SUCCESS,
  payload: id,
});

export const getFeedbackSuccess = (feedback) => ({
  type: GET_FEEDBACKS_SUCCESS,
  payload: feedback,
});

export const fetchEscalationsSuccess = (escalations) => ({
  type: FETCH_ESCALATIONS_SUCCESS,
  payload: escalations,
});

export const receiveRealtimeFeedback = (payload) => ({
  type: REALTIME_FEEDBACK_RECEIVED,
  payload,
});

export const fetchFeedbacks = (params = {}) => {
  return async (dispatch) => {
    dispatch(feedbackRequest());
    try {
      const data = await listFeedbacks(params);
      dispatch(fetchFeedbacksSuccess(data));
      return data;
    } catch (error) {
      const resData = error?.response?.data;
      const messageText =
        resData?.error || resData?.message || "Lỗi khi tải phản ánh";
      dispatch(feedbackFailure(messageText));
      throw new Error(messageText);
    }
  };
};

export const fetchEscalations = (params = {}) => {
  return async (dispatch) => {
    dispatch(feedbackRequest());
    try {
      const data = await listEscalations(params);
      dispatch(fetchEscalationsSuccess(data));
      return data;
    } catch (error) {
      const resData = error?.response?.data;
      const messageText =
        resData?.error || resData?.message || "Lỗi khi tải danh sách leo thang";
      dispatch(feedbackFailure(messageText));
      throw new Error(messageText);
    }
  };
};

/**
 * Phân công phản ánh
 */
export const assignFeedback = (id, data) => {
  return async (dispatch) => {
    dispatch(feedbackRequest());
    try {
      const responseData = await updateFeedback({
        id,
        data: { ...data, status: "assigned" },
      });
      dispatch(updateFeedbackSuccess(responseData));
      return responseData;
    } catch (error) {
      const messageText =
        error?.response?.data?.message || "Lỗi khi phân công xử lý";
      dispatch(feedbackFailure(messageText));
      throw new Error(messageText);
    }
  };
};

/**
 * Tiếp nhận phản ánh
 */
export const acceptFeedback = (id, data = {}) => {
  return async (dispatch) => {
    dispatch(feedbackRequest());
    try {
      const responseData = await acceptFeedbackService({ id, data });
      dispatch(updateFeedbackSuccess(responseData));
      return responseData;
    } catch (error) {
      const resData = error?.response?.data;
      const messageText =
        resData?.error || resData?.message || "Lỗi khi tiếp nhận phản ánh";
      dispatch(feedbackFailure(messageText));
      throw new Error(messageText);
    }
  };
};

/**
 * Chuyển tiếp phản ánh
 */
export const reassignFeedback = (id, data) => {
  return async (dispatch) => {
    dispatch(feedbackRequest());
    try {
      const responseData = await reassignFeedbackService({ id, data });
      dispatch(updateFeedbackSuccess(responseData));
      return responseData;
    } catch (error) {
      const resData = error?.response?.data;
      const messageText =
        resData?.error || resData?.message || "Lỗi khi chuyển tiếp phản ánh";
      dispatch(feedbackFailure(messageText));
      throw new Error(messageText);
    }
  };
};

/**
 * Bắt đầu xử lý phản ánh
 */
export const startProcessingFeedback = (id) => {
  return async (dispatch) => {
    dispatch(feedbackRequest());
    try {
      const responseData = await startProcessingFeedbackService({ id });
      dispatch(updateFeedbackSuccess(responseData));
      return responseData;
    } catch (error) {
      const resData = error?.response?.data;
      const messageText =
        resData?.error || resData?.message || "Lỗi khi bắt đầu xử lý phản ánh";
      dispatch(feedbackFailure(messageText));
      throw new Error(messageText);
    }
  };
};

/**
 * Đóng phản ánh
 */
export const closeFeedback = (id) => {
  return async (dispatch) => {
    dispatch(feedbackRequest());
    try {
      const responseData = await updateFeedback({
        id,
        data: { status: "closed" },
      });
      dispatch(updateFeedbackSuccess(responseData));
      return responseData;
    } catch (error) {
      const messageText =
        error?.response?.data?.message || "Lỗi khi đóng phản ánh";
      dispatch(feedbackFailure(messageText));
      throw new Error(messageText);
    }
  };
};

/**
 * @param {Object} feedbackData
 */
export const addFeedback = (feedbackData) => {
  return async (dispatch) => {
    dispatch(feedbackRequest());
    try {
      const data = await createFeedback({ data: feedbackData });
      dispatch(createFeedbackSuccess(data));
      return data;
    } catch (error) {
      const resData = error?.response?.data;
      const messageText =
        resData?.error || resData?.message || "Lỗi khi tạo phản ánh";
      dispatch(feedbackFailure(messageText));
      throw new Error(messageText);
    }
  };
};

/**
 * @param {string} id - ID của phản ánh
 * @param {Object} feedbackData
 */
export const editFeedback = (id, feedbackData) => {
  return async (dispatch) => {
    dispatch(feedbackRequest());
    try {
      const data = await updateFeedback({ id, data: feedbackData });
      dispatch(updateFeedbackSuccess(data));
      return data;
    } catch (error) {
      const resData = error?.response?.data;
      const messageText =
        resData?.error || resData?.message || "Lỗi khi cập nhật phản ánh";
      dispatch(feedbackFailure(messageText));
      throw new Error(messageText);
    }
  };
};

/**
 * @param {string} id - ID của phản ánh cần lấy
 */
export const fetchFeedback = (id) => {
  return async (dispatch) => {
    dispatch(feedbackRequest());
    try {
      const data = await getFeedbackService({ id });
      dispatch(getFeedbackSuccess(data));
      return data;
    } catch (error) {
      const message =
        error?.response?.data?.message || "Lỗi khi lấy thông tin phản ánh";
      dispatch(feedbackFailure(message));
      return null;
    }
  };
};

/**
 * @param {string} id - ID của phản ánh cần xóa
 */
export const removeFeedback = (id) => {
  return async (dispatch) => {
    dispatch(feedbackRequest());
    try {
      await deleteFeedback({ id });
      dispatch(deleteFeedbackSuccess(id));
      return true;
    } catch (error) {
      const resData = error?.response?.data;
      const messageText =
        resData?.error || resData?.message || "Lỗi khi xóa phản ánh";
      dispatch(feedbackFailure(messageText));
      throw new Error(messageText);
    }
  };
};

/**
 * Cập nhật tiến độ phản ánh
 */
export const updateProgressFeedback = (id, data) => {
  return async (dispatch) => {
    dispatch(feedbackRequest());
    try {
      const responseData = await updateProgressFeedbackService({ id, data });
      dispatch(updateFeedbackSuccess(responseData));
      return responseData;
    } catch (error) {
      const resData = error?.response?.data;
      const messageText =
        resData?.error || resData?.message || "Lỗi khi cập nhật tiến độ";
      dispatch(feedbackFailure(messageText));
      throw new Error(messageText);
    }
  };
};

/**
 * Hoàn thành & phản hồi phản ánh
 */
export const respondFeedback = (id, data) => {
  return async (dispatch) => {
    dispatch(feedbackRequest());
    try {
      const responseData = await respondFeedbackService({ id, data });
      dispatch(updateFeedbackSuccess(responseData));
      return responseData;
    } catch (error) {
      const resData = error?.response?.data;
      const messageText =
        resData?.error || resData?.message || "Lỗi khi gửi phản hồi";
      dispatch(feedbackFailure(messageText));
      throw new Error(messageText);
    }
  };
};

/**
 * Cập nhật kết quả xử lý + minh chứng
 */
export const resultUpdateFeedback = (id, data) => {
  return async (dispatch) => {
    dispatch(feedbackRequest());
    try {
      const responseData = await resultUpdateFeedbackService({ id, data });
      dispatch(updateFeedbackSuccess(responseData));
      return responseData;
    } catch (error) {
      const resData = error?.response?.data;
      const messageText =
        resData?.error || resData?.message || "Lỗi khi cập nhật kết quả";
      dispatch(feedbackFailure(messageText));
      throw new Error(messageText);
    }
  };
};

/**
 * Đề xuất chỉ huy điều phối
 */
export const proposeChiefFeedback = (id, data) => {
  return async (dispatch) => {
    dispatch(feedbackRequest());
    try {
      const responseData = await proposeChiefFeedbackService({ id, data });
      dispatch(updateFeedbackSuccess(responseData));
      return responseData;
    } catch (error) {
      const resData = error?.response?.data;
      const messageText =
        resData?.error || resData?.message || "Lỗi khi đề xuất chỉ huy";
      dispatch(feedbackFailure(messageText));
      throw new Error(messageText);
    }
  };
};

/**
 * Mời cán bộ phối hợp
 */
export const collaborateFeedback = (id, data) => {
  return async (dispatch) => {
    dispatch(feedbackRequest());
    try {
      const responseData = await collaborateFeedbackService({ id, data });
      dispatch(updateFeedbackSuccess(responseData));
      return responseData;
    } catch (error) {
      const resData = error?.response?.data;
      const messageText =
        resData?.error || resData?.message || "Lỗi khi mời phối hợp";
      dispatch(feedbackFailure(messageText));
      throw new Error(messageText);
    }
  };
};

/**
 * Tăng cường lực lượng
 */
export const reinforceFeedback = (id, data) => {
  return async (dispatch) => {
    dispatch(feedbackRequest());
    try {
      const responseData = await reinforceFeedbackService({ id, data });
      dispatch(updateFeedbackSuccess(responseData));
      return responseData;
    } catch (error) {
      const resData = error?.response?.data;
      const messageText =
        resData?.error || resData?.message || "Lỗi khi tăng cường lực lượng";
      dispatch(feedbackFailure(messageText));
      throw new Error(messageText);
    }
  };
};

/**
 * Chỉ huy nhận điều phối
 */
export const acceptProposeFeedback = (id) => {
  return async (dispatch) => {
    dispatch(feedbackRequest());
    try {
      const responseData = await acceptProposeFeedbackService({ id });
      dispatch(updateFeedbackSuccess(responseData));
      return responseData;
    } catch (error) {
      const resData = error?.response?.data;
      const messageText =
        resData?.error || resData?.message || "Lỗi khi nhận điều phối";
      dispatch(feedbackFailure(messageText));
      throw new Error(messageText);
    }
  };
};

/**
 * Đánh dấu xử lý xong tại hiện trường
 */
export const resolveWorkflowFeedback = (id) => {
  return async (dispatch) => {
    dispatch(feedbackRequest());
    try {
      const responseData = await resolveWorkflowFeedbackService({ id });
      dispatch(updateFeedbackSuccess(responseData));
      return responseData;
    } catch (error) {
      const resData = error?.response?.data;
      const messageText =
        resData?.error || resData?.message || "Lỗi khi đánh dấu xử lý xong";
      dispatch(feedbackFailure(messageText));
      throw new Error(messageText);
    }
  };
};

/**
 * Điều chỉnh mức độ ưu tiên
 */
export const changePriorityFeedback = (id, data) => {
  return async (dispatch) => {
    dispatch(feedbackRequest());
    try {
      const responseData = await changePriorityFeedbackService({ id, data });
      dispatch(updateFeedbackSuccess(responseData));
      return responseData;
    } catch (error) {
      const resData = error?.response?.data;
      const messageText =
        resData?.error || resData?.message || "Lỗi khi điều chỉnh mức độ";
      dispatch(feedbackFailure(messageText));
      throw new Error(messageText);
    }
  };
};
/**
 * Tiếp nhận phối hợp
 */
export const acceptCollaborationFeedback = (id) => {
  return async (dispatch) => {
    dispatch(feedbackRequest());
    try {
      const responseData = await acceptCollaborationFeedbackService({ id });
      dispatch(updateFeedbackSuccess(responseData));
      return responseData;
    } catch (error) {
      const resData = error?.response?.data;
      const messageText =
        resData?.error || resData?.message || "Lỗi khi tiếp nhận phối hợp";
      dispatch(feedbackFailure(messageText));
      throw new Error(messageText);
    }
  };
};

/**
 * Chuyển tiếp phối hợp
 */
export const forwardCollaborationFeedback = (id, data) => {
  return async (dispatch) => {
    dispatch(feedbackRequest());
    try {
      const responseData = await forwardCollaborationFeedbackService({
        id,
        data,
      });
      dispatch(updateFeedbackSuccess(responseData));
      return responseData;
    } catch (error) {
      const resData = error?.response?.data;
      const messageText =
        resData?.error || resData?.message || "Lỗi khi chuyển tiếp phối hợp";
      dispatch(feedbackFailure(messageText));
      throw new Error(messageText);
    }
  };
};

/**
 * Chỉ đạo phản ánh
 */
export const directiveFeedback = (id, data) => {
  return async (dispatch) => {
    dispatch(feedbackRequest());
    try {
      const responseData = await directiveFeedbackService({ id, data });
      dispatch(updateFeedbackSuccess(responseData));
      return responseData;
    } catch (error) {
      const resData = error?.response?.data;
      const messageText =
        resData?.error || resData?.message || "Lỗi khi gửi chỉ đạo";
      dispatch(feedbackFailure(messageText));
      throw new Error(messageText);
    }
  };
};
